import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Row, Col } from 'react-bootstrap';

const getPrintableMetric = (val) => {
  if (val === undefined || val === null) {
    return 'N/A';
  }

  if (typeof(val) === 'number') {
    return `${val}%`;
  }

  return `${val.value}% (${val.image})`;
};

const StatisticsModalComponent = ({
  visible,
  stats,
  currentNames,
  baselineNames,
  onHide
}) => (
  <Modal show={visible} onHide={onHide} bsSize="lg">
    <Modal.Header closeButton>
      <Modal.Title>
        Statistics for {currentNames.join(', ')} vs. {baselineNames.join(', ')}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Row>
        <Col md={4}>Median Duration Difference:</Col>
        <Col
          md={8}
          className={(stats.median && stats.median.value) > 0 ? 'bad-metric' : undefined}
        >
          {getPrintableMetric(stats.median && stats.median.value)}
        </Col>
      </Row>
      <Row>
        <Col md={4}>Mean Duration Difference:</Col>
        <Col md={8} className={stats.average > 0 ? 'bad-metric' : undefined}>
          {getPrintableMetric(stats.average)}
        </Col>
      </Row>
      <Row>
        <Col md={4}>Minimum Performance Improvement:</Col>
        <Col md={8}>{getPrintableMetric(stats.minImprovement)}</Col>
      </Row>
      <Row>
        <Col md={4}>Maximum Performance Improvement:</Col>
        <Col md={8}>{getPrintableMetric(stats.maxImprovement)}</Col>
      </Row>
      <Row>
        <Col md={4}>Minimum Performance Reduction:</Col>
        <Col
          md={8}
          className={
            stats.minReduction !== null && stats.minReduction !== undefined ?
              'bad-metric' :
              undefined
          }
        >
          {getPrintableMetric(stats.minReduction)}
        </Col>
      </Row>
      <Row>
        <Col md={4}>Maximum Performance Reduction:</Col>
        <Col
          md={8}
          className={
            stats.maxReduction !== null && stats.maxReduction !== undefined ?
              'bad-metric' :
              undefined
          }
        >
          {getPrintableMetric(stats.maxReduction)}
        </Col>
      </Row>
    </Modal.Body>
  </Modal>
);

StatisticsModalComponent.propTypes = {
  visible: PropTypes.bool,
  stats: PropTypes.object.isRequired,
  currentNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  baselineNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  onHide: PropTypes.func.isRequired
};

export default StatisticsModalComponent;


// WEBPACK FOOTER //
// src/Components/StatisticsModalComponent.jsx